// eslint-disable-next-line import/prefer-default-export
export const FORM_RECEIVERS = {
  OTHERS: "others",
  EMPLOYEE: "employee",
};

export const FORM_TYPES = {
  ACTIVE_FORMS: "activeForms",
  FORMS: "forms",
};

export const FORM_TYPES_BY_RECEIVERS = {
  OTHERS_FORMS: "othersForms",
  EMPLOYEE_FORMS: "employeeForms",
};

export const newDataIsSavedText = "Nowe dane zostały zapisane";
export const newDataIsNotSavedText = "Nowe dane nie zostały zapisane";
export const newEmailIsSavedText = "Na podany e-mail został wysłany formularz";

export const FORM_STATUSES = {
  BENEFIT_ACTIVE: "benefitActive",
  FORM_COMPLETED: "formCompleted",
  DEFAULT: "default",
  EMAIL_TO_OTHER_SENT_BUT_NOT_COMPLETED: "emailToOtherSentButNotCompleted",
};
